module.exports = __webpack_public_path__ + "bb20e4a11fb64f82078c7bcbbab8691e.png";